import {
  CardHeader as KitbagCardHeader,
  Typography,
} from '@statsbomb/kitbag-components';
import PropTypes from 'prop-types';
import React from 'react';

export function CardHeader({ children }) {
  return (
    <KitbagCardHeader>
      <Typography variant="headingLarge">{children}</Typography>
    </KitbagCardHeader>
  );
}

CardHeader.propTypes = {
  children: PropTypes.node.isRequired,
};

export default { CardHeader };
